import { useEffect, useState } from "react";
import CauHinhApi from "service/cauHinhApi";
import PhanQuyenApi from "service/phanQuyenApi";
import cauHinh from "utils/cauHinh";

// Nhóm quyền "Thông tin khách vay" (thongtinkhachvay*) là nâng cấp đặt riêng,
// không bật cho bản chung. Vì dùng chung codebase nên toàn bộ phần này nằm sau
// cấu hình `isPhanQuyenThongTinKhachHang`: chưa bật thì kiemTraQuyen() luôn trả
// về true, mọi tab / nút hiển thị đúng như bản chung và cũng không gọi thêm API
// phân quyền nào.
let promiseCauHinhPhanQuyenTTKH = null;
let batPhanQuyenTTKH = null; // null = chưa đọc xong cấu hình

export const layCauHinhPhanQuyenTTKH = () => {
  if (!promiseCauHinhPhanQuyenTTKH) {
    promiseCauHinhPhanQuyenTTKH = CauHinhApi.getConfigSys1()
      .then((response) => {
        if (response.ok && Array.isArray(response.data)) {
          const config = response.data.find(
            (e) =>
              (e.keyConfig || "").toUpperCase() ===
              cauHinh.sKey.IsPhanQuyenThongTinKhachHang.toUpperCase()
          );
          batPhanQuyenTTKH = config != null && config.valueConfig === "1";
          return batPhanQuyenTTKH;
        }
        // Không cache kết quả lỗi để lần sau còn gọi lại được.
        // Đọc cấu hình hỏng thì chạy như bản chung, không ẩn gì cả.
        promiseCauHinhPhanQuyenTTKH = null;
        return false;
      })
      .catch(() => {
        promiseCauHinhPhanQuyenTTKH = null;
        return false;
      });
  }
  return promiseCauHinhPhanQuyenTTKH;
};

// phanquyen/GetAllQuyen trả về toàn bộ module code của user đang đăng nhập
// (shopadmin nhận hết các code có trong bảng Roles). Danh sách này không đổi
// trong 1 phiên làm việc — chuyển cửa hàng đã reload lại trang — nên chỉ gọi
// đúng 1 lần rồi dùng chung cho mọi component.
let promiseDanhSachQuyen = null;
let dsQuyen = null; // null = chưa tải xong

export const layDanhSachQuyen = () => {
  if (!promiseDanhSachQuyen) {
    promiseDanhSachQuyen = PhanQuyenApi.getAllQuyen()
      .then((response) => {
        if (response.ok && Array.isArray(response.data)) {
          dsQuyen = response.data.map((item) =>
            (item.ModuleCode || "").toUpperCase()
          );
          return dsQuyen;
        }
        // Không cache kết quả lỗi để lần sau còn gọi lại được
        promiseDanhSachQuyen = null;
        return [];
      })
      .catch(() => {
        promiseDanhSachQuyen = null;
        return [];
      });
  }
  return promiseDanhSachQuyen;
};

// Danh sách quyền được cache cả phiên. Sau khi vừa lưu phân quyền thì bản cache
// không còn đúng nữa, gọi hàm này để lần hỏi sau đọc lại từ server.
export const xoaCacheDanhSachQuyen = () => {
  promiseDanhSachQuyen = null;
  dsQuyen = null;
};

export const kiemTraQuyen = (code) =>
  layCauHinhPhanQuyenTTKH().then((bat) => {
    // Bản chung: giữ nguyên hành vi cũ, không kiểm tra quyền
    if (!bat) return true;
    return layDanhSachQuyen().then(
      (danhSach) => danhSach.indexOf((code || "").toUpperCase()) >= 0
    );
  });

// Giá trị dùng cho lần render đầu tiên (state khởi tạo) — đồng bộ, không chờ API.
// Chưa biết cấu hình thì coi như CÓ quyền: bản chung nhờ vậy không bị nháy
// ẩn/hiện tab trong lúc chờ đọc cấu hình.
export const quyenBanDau = (code) => {
  if (batPhanQuyenTTKH !== true || dsQuyen === null) return true;
  return dsQuyen.indexOf((code || "").toUpperCase()) >= 0;
};

export const useQuyen = (code) => {
  const [coQuyen, setCoQuyen] = useState(() => quyenBanDau(code));
  useEffect(() => {
    let conMount = true;
    kiemTraQuyen(code).then((ketQua) => {
      if (conMount) setCoQuyen(ketQua);
    });
    return () => {
      conMount = false;
    };
  }, [code]);
  return coQuyen;
};
